var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesBgIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 465,
    viewBox: "0 0 568 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 232.5,
    cy: 232.5,
    r: 232.5,
    fill: "url(#paint0_linear_1043_89173)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 279.454,
    y: 162.275,
    width: 118.653,
    height: 298.514,
    rx: 59.3265,
    transform: "rotate(-49.9455 279.454 162.275)",
    stroke: "url(#paint1_linear_1043_89173)",
    strokeWidth: 12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_89173",
    x1: 232.5,
    y1: 0,
    x2: 232.5,
    y2: 465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4FCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EEAD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_89173",
    x1: 336.327,
    y1: 163.006,
    x2: 336.327,
    y2: 473.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98B6F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBgIc);
export default __webpack_public_path__ + "static/media/servicesBg_ic.146f8cd2.svg";
export { ForwardRef as ReactComponent };